import * as React from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import {
  BannerHome,
  ContractHealth,
  ContractHome,
  DateFilterLayout,
  CSratingsLayout,
  EcsHome,
  EditBusinessHome,
  Grievance,
  Layout,
  Leads,
  Payments,
  PaymentsHistory,
  UserReport,
  TicketCreateNew,
} from './components';
import { CSratings, ReviewSuccess, Faq, Home, TicketCreate, TicketsList, GenioFaq, ErrorPage } from './pages';
import ChatbotRedirect from './pages/ChatbotRedirect';
import './styles';
import { GenioLayout } from './components/Layout';
import { CategoriesTicketCreate, GenioLandingPage, GenioLeads, GenioOptions } from './components/Genio';
import ReportErrorPage from './pages/ReportErrorPage';
import DummyTicketPage from './components/TicketCreateNew/DummyTicketPage';

console.log('***********New RepoChange1***************');
export const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/csportal" replace />,
  },
  {
    path: '*',
    element: <ErrorPage />,
  },
  {
    path: '/unauthorized',
    element: <h3>You are not authorized</h3>,
  },
  {
    path: '/csportal',
    errorElement: <ReportErrorPage />,
    element: <Layout />,
    children: [
      {
        path: '/csportal',
        element: <Home />,
      },
    ],
  },
  {
    path: '/csportal',
    errorElement: <ReportErrorPage />,
    element: <Layout />,
    children: [
      {
        path: '/csportal/ecs',
        element: <EcsHome />,
      },
      {
        path: '/csportal/edit_business',
        element: <EditBusinessHome />,
      },
      {
        path: '/csportal/contract',
        element: <ContractHome />,
      },
      {
        path: '/csportal/payments',
        element: <Payments />,
      },
      {
        path: '/csportal/payment_history',
        element: <PaymentsHistory />,
      },
      {
        path: '/csportal/leads',
        element: <Leads />,
      },
      {
        path: '/csportal/leads/contract_health',
        element: <ContractHealth />,
      },
      {
        path: '/csportal/create_ticket',
        element: <TicketCreate />,
      },
      {
        path: '/csportal/faq/:key',
        element: <Faq />,
      },
      {
        path: '/csportal/userReport',
        element: <UserReport />,
      },
      {
        path: '/csportal/grievance',
        element: <Grievance />,
      },
      {
        path: '/csportal/create_ticket_new',
        element: <TicketCreateNew />,
      },
      {
        path: '/csportal/create_ticket_page',
        element: <DummyTicketPage />,
      },
    ],
  },
  {
    path: '/csportal',
    errorElement: <ReportErrorPage />,
    element: <DateFilterLayout />,
    children: [
      {
        path: '/csportal/myTickets',
        element: <TicketsList />,
      },
    ],
  },
  {
    path: '/ratings',
    errorElement: <ReportErrorPage />,
    element: <CSratingsLayout />,
    children: [
      {
        path: '/ratings',
        element: <CSratings />,
      },
    ],
  },
  {
    path: '/ratings/success',
    element: <ReviewSuccess />,
  },
  {
    path: '/csportal/banner',
    errorElement: <ReportErrorPage />,
    element: <BannerHome />,
  },
  {
    path: '/csportal/chatbot',
    element: <ChatbotRedirect />,
  },
  {
    path: '/genio',
    errorElement: <ReportErrorPage />,
    element: <GenioLayout />,
    children: [
      {
        path: '/genio',
        element: <GenioLandingPage />,
      },
      {
        path: '/genio/features',
        element: <GenioOptions />,
      },
      {
        path: '/genio/category_create_ticket',
        element: <CategoriesTicketCreate />,
      },
      {
        path: '/genio/faq/:key',
        element: <GenioFaq />,
      },
      {
        path: '/genio/edit_business',
        element: <EditBusinessHome />,
      },
      {
        path: '/genio/contract',
        element: <ContractHome />,
      },
      {
        path: '/genio/payments',
        element: <Payments />,
      },
      {
        path: '/genio/payment_history',
        element: <PaymentsHistory />,
      },
      {
        path: '/genio/leads',
        element: <GenioLeads />,
      },
      {
        path: '/genio/leads/contract_health',
        element: <ContractHealth />,
      },
      {
        path: '/genio/create_ticket',
        element: <TicketCreate />,
      },
      {
        path: '/genio/ecs',
        element: <EcsHome />,
      },
    ],
  },
  {
    path: '/genio/banner',
    errorElement: <ReportErrorPage />,
    element: <BannerHome />,
  },
  {
    path: '/genio',
    errorElement: <ReportErrorPage />,
    element: <DateFilterLayout />,
    children: [
      {
        path: '/genio/myTickets',
        element: <TicketsList />,
      },
    ],
  },
]);
